import { io } from "socket.io-client";

class SocketioService {
  socket;
  constructor() { }

  setupSocketConnection() {
    this.socket = io(process.env.VUE_APP_GLOBAL_MESSAGING, {
      reconnection: true,          // Enable reconnection
      reconnectionAttempts: 5000,    // Number of reconnection attempts
      reconnectionDelay: 4000,     // Time delay in milliseconds between attempts
      reconnectionDelayMax: 8000,  // Maximum reconnection delay
    });

    // Handle reconnection events
    this.socket.on("connect", () => {
      console.log("trip Socket connected");
    });

    this.socket.on("reconnect", (attemptNumber) => {
      console.log(`Socket reconnected after ${attemptNumber} attempts`);
    });

    this.socket.on("reconnect_error", (error) => {
      console.error("Socket reconnection error:", error);
    });
  }


  connected() {
    this.socket.on("connect", () => {
      console.log("trip socket connection: ", this.socket.connected); // true
    });
  }

  registerTripId(val) {
    this.socket.emit("trip_driver", { trip_id: val });
  }

  registerBatchTripId(val) {
    this.socket.emit("batch_trip_driver", { trip_id: val });
    console.log('bacth trip registered', val)
  }

  registerFetchDriverLocation(val) {
    this.socket.emit("fetch_driver_location", { trip_id: val });
    console.log('bacth fetch trip registered', val)
  }

  tripInfo(val) {
    return new Promise((resolve, reject) => {
      this.socket.on(val, (msg) => {
        let response = msg;
        resolve(response); // Resolve the promise with the response
      });

      // Handle any errors
      this.socket.on("error", (error) => {
        reject(error);
      });
    });
  }

  

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      console.log("trip socket disconnected");
    }
  }
}

export default new SocketioService();
